<template>
  <main class="join-snkrhud-community">

  </main>
</template>
<script>
export default {
  name: 'JoinSnkrhudCommunity',
};
</script>
<style lang="scss">
@import "../assets/styles/joinsnkrhudcommunity.scss";
</style>
